import { createAction, props } from "@ngrx/store";
import { StorageNativeStoreAction } from "src/components/shared-components/enum/enumStoreAction";

/**
 * Storage action to unset all key
 */
export const storageUnsetAllAuthKeyAction = createAction(
  StorageNativeStoreAction.STORAGE_UNSET_ALL_AUTH_KEY
);
